import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { FooterComponent } from "./footer/footer.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import {AuthNavbarComponent} from "./auth-navbar/auth-navbar.component";
import {ContactUsFooterComponent} from "./contact-us-footer/contact-us-footer.component";
import {CommonSharedModule} from "../common/module/common-shared.module";

@NgModule({
  imports: [CommonSharedModule, RouterModule],
  declarations: [FooterComponent, NavbarComponent, SidebarComponent, AuthNavbarComponent, ContactUsFooterComponent],
  exports: [FooterComponent, NavbarComponent, SidebarComponent, AuthNavbarComponent, ContactUsFooterComponent]
})
export class ComponentsModule {}
